(function () {
  'use strict';

  var KEY_WORD = 'Delegate';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function cleanName(raw) {
    return String(raw).replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function plural(w) {
    if (/[^aeiou]y$/i.test(w)) { return w.slice(0, -1) + 'ies'; }
    if (/(s|x|z|ch|sh)$/i.test(w)) { return w + 'es'; }
    return w + 's';
  }

  function parsePasted(text) {
    return String(text)
      .split(/[\r\n]+/)
      .map(function (line) { return cleanName(line.replace(/^\s*\d+[.)]\s*/, '')); })
      .filter(function (n) { return n.length >= 2; });
  }

  function cartForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var id = forms[i].id || '';
      if (id.indexOf('installment') !== -1) { continue; }
      return forms[i];
    }
    return null;
  }

  function init(root) {
    if (root.dataset.envicoReady === 'true') { return; }
    root.dataset.envicoReady = 'true';

    var mode = root.dataset.mode || 'dated';
    var label = root.dataset.label || 'Delegate';
    var labelLower = label.toLowerCase();
    var pluralLower = plural(label).toLowerCase();
    var allowDefer = root.dataset.allowDefer === 'true';

    var cap = parseInt(root.dataset.cap, 10);
    if (isNaN(cap)) { cap = 12; }
    cap = Math.max(1, Math.min(200, cap));

    var minLen = 2;
    var names = [''];
    var deferred = false;

    var rowsEl = root.querySelector('[data-rows]');
    var addBtn = root.querySelector('[data-add]');
    var pasteBtn = root.querySelector('[data-paste-toggle]');
    var pasteBox = root.querySelector('[data-paste-box]');
    var pasteArea = root.querySelector('[data-paste-area]');
    var pasteApply = root.querySelector('[data-paste-apply]');
    var pasteCancel = root.querySelector('[data-paste-cancel]');
    var capNote = root.querySelector('[data-cap-note]');
    var deferNote = root.querySelector('[data-defer-note]');
    var errNote = root.querySelector('[data-err-note]');
    var deferWrap = root.querySelector('[data-defer-wrap]');
    var deferChk = root.querySelector('[data-defer-check]');
    var deferPanel = root.querySelector('[data-defer-panel]');
    var deferQty = root.querySelector('[data-defer-qty]');
    var namedPanel = root.querySelector('[data-named-panel]');

    var capMessage = 'Maximum ' + cap + ' ' + pluralLower +
      ' per booking. Contact us for a quote on larger groups.';

    function showDeferNote() {
      if (!deferNote) { return; }
      deferNote.textContent = capMessage;
      deferNote.style.display = '';
    }

    function hideDeferNote() {
      if (deferNote) { deferNote.style.display = 'none'; }
    }

    function deferCount() {
      var raw = parseInt(deferQty ? deferQty.value : '1', 10);
      if (isNaN(raw) || raw < 1) { raw = 1; }
      if (raw > cap) {
        showDeferNote();
        return cap;
      }
      if (raw === cap) { showDeferNote(); } else { hideDeferNote(); }
      return raw;
    }

    function hideThemeQty() {
      var wraps = document.querySelectorAll('quantity-input');
      for (var i = 0; i < wraps.length; i++) { wraps[i].style.display = 'none'; }
    }

    function writeInto(targetForm) {
      if (!targetForm) { return; }

      var old = targetForm.querySelectorAll('[data-envico-prop]');
      for (var i = 0; i < old.length; i++) {
        old[i].parentNode.removeChild(old[i]);
      }

      function put(name, value) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = name;
        h.value = value;
        h.setAttribute('data-envico-prop', 'true');
        targetForm.appendChild(h);
      }

      var count = 1;
      if (mode !== 'none') {
        if (deferred) {
          count = deferCount();
          put('properties[' + plural(KEY_WORD) + ']', 'To follow');
          put('properties[_Names pending]', 'true');
        } else {
          count = names.length;
          var filled = [];
          names.forEach(function (n, i) {
            var clean = cleanName(n);
            if (clean.length >= minLen) {
              put('properties[' + KEY_WORD + ' ' + (i + 1) + ']', clean);
              filled.push(clean);
            }
          });
          if (filled.length) {
            put('properties[' + plural(KEY_WORD) + ']', filled.join(', '));
          }
        }
      }

      var qtys = targetForm.querySelectorAll('input[name="quantity"]');
      var external = document.querySelectorAll('input[name="quantity"]');
      var k;
      for (k = 0; k < qtys.length; k++) { qtys[k].value = count; }
      for (k = 0; k < external.length; k++) {
        if (external[k].getAttribute('form') === targetForm.id) { external[k].value = count; }
      }
      if (qtys.length === 0) {
        var q = document.createElement('input');
        q.type = 'hidden';
        q.name = 'quantity';
        q.value = count;
        q.setAttribute('data-envico-prop', 'true');
        targetForm.appendChild(q);
      }
    }

    function sync() {
      writeInto(cartForm());
    }

    function buildRows() {
      if (mode === 'none') { hideThemeQty(); sync(); return; }
      rowsEl.innerHTML = '';

      names.forEach(function (value, i) {
        var row = document.createElement('div');
        row.className = 'envico-delegate-row';

        var num = document.createElement('span');
        num.className = 'envico-delegate-num';
        num.textContent = (i + 1) + '.';

        var input = document.createElement('input');
        input.type = 'text';
        input.className = 'envico-delegate-input';
        input.value = value;
        input.placeholder = 'Full name';
        input.autocomplete = 'off';
        input.setAttribute('aria-label', label + ' ' + (i + 1) + ' full name');
        input.addEventListener('input', function () {
          names[i] = input.value;
          input.classList.remove('is-invalid');
          hideError();
          sync();
        });

        row.appendChild(num);
        row.appendChild(input);

        if (names.length > 1) {
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'envico-delegate-remove';
          rm.innerHTML = '&times;';
          rm.setAttribute('aria-label', 'Remove ' + labelLower + ' ' + (i + 1));
          rm.addEventListener('click', function () {
            names.splice(i, 1);
            hideError();
            buildRows();
          });
          row.appendChild(rm);
        }

        rowsEl.appendChild(row);
      });

      var atCap = names.length >= cap;
      addBtn.style.display = atCap ? 'none' : '';
      capNote.style.display = atCap ? '' : 'none';
      capNote.textContent = capMessage;

      hideThemeQty();
      sync();
    }

    function showError(msg) {
      errNote.textContent = msg;
      errNote.style.display = '';
    }

    function hideError() {
      errNote.style.display = 'none';
    }

    function updateDeferUi() {
      if (!deferWrap) { return; }
      deferWrap.style.display = allowDefer ? '' : 'none';
      if (!allowDefer) { deferred = false; }
      if (namedPanel) { namedPanel.style.display = deferred ? 'none' : ''; }
      if (deferPanel) { deferPanel.style.display = deferred ? '' : 'none'; }
    }

    function validate() {
      if (mode === 'none' || deferred) { return true; }
      var inputs = rowsEl.querySelectorAll('.envico-delegate-input');
      var firstBad = -1;
      names.forEach(function (n, i) {
        var ok = cleanName(n).length >= minLen;
        if (inputs[i]) { inputs[i].classList.toggle('is-invalid', !ok); }
        if (!ok && firstBad === -1) { firstBad = i; }
      });
      if (firstBad === -1) { hideError(); return true; }
      showError('Enter a name for ' + labelLower + ' ' + (firstBad + 1) + ', or remove that row.');
      if (inputs[firstBad]) { inputs[firstBad].focus(); }
      return false;
    }

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) { return; }
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) { return; }
      if (f.id && f.id.indexOf('installment') !== -1) { return; }

      if (!validate()) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
        return;
      }
      writeInto(f);
    }, true);

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[name="add"], button[type="submit"]') : null;
      if (!btn) { return; }
      var owner = btn.form || btn.closest('form');
      if (!owner) { return; }
      var act = owner.getAttribute('action') || '';
      if (act.indexOf('/cart/add') === -1) { return; }
      if (validate()) { writeInto(owner); }
    }, true);

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (names.length < cap) {
          names.push('');
          buildRows();
          var inputs = rowsEl.querySelectorAll('.envico-delegate-input');
          if (inputs.length) { inputs[inputs.length - 1].focus(); }
        }
      });
    }

    if (pasteBtn) {
      pasteBtn.addEventListener('click', function () {
        var open = pasteBox.style.display !== 'none';
        pasteBox.style.display = open ? 'none' : '';
        if (!open) { pasteArea.focus(); }
      });
    }

    if (pasteCancel) {
      pasteCancel.addEventListener('click', function () {
        pasteBox.style.display = 'none';
        pasteArea.value = '';
      });
    }

    if (pasteApply) {
      pasteApply.addEventListener('click', function () {
        var parsed = parsePasted(pasteArea.value);
        if (!parsed.length) { return; }
        var over = parsed.length > cap;
        names = parsed.slice(0, cap);
        pasteBox.style.display = 'none';
        pasteArea.value = '';
        buildRows();
        if (over) {
          showError('Pasted list trimmed to the maximum of ' + cap + '. Contact us for a quote on larger groups.');
        }
      });
    }

    if (deferChk) {
      deferChk.addEventListener('change', function () {
        deferred = deferChk.checked;
        hideError();
        updateDeferUi();
        sync();
      });
    }

    var deferUp = root.querySelector('[data-defer-up]');
    var deferDown = root.querySelector('[data-defer-down]');
    if (deferUp) {
      deferUp.addEventListener('click', function () {
        var next = deferCount() + 1;
        if (next > cap) { next = cap; showDeferNote(); }
        deferQty.value = next;
        sync();
      });
    }
    if (deferDown) {
      deferDown.addEventListener('click', function () {
        deferQty.value = Math.max(1, deferCount() - 1);
        sync();
      });
    }

    if (deferQty) {
      deferQty.addEventListener('input', function () {
        var raw = parseInt(deferQty.value, 10);
        if (!isNaN(raw) && raw > cap) { showDeferNote(); } else { hideDeferNote(); }
        sync();
      });
      deferQty.addEventListener('blur', function () {
        deferQty.value = deferCount();
        sync();
      });
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        setTimeout(hideThemeQty, 0);
        setTimeout(sync, 0);
        setTimeout(hideThemeQty, 400);
        setTimeout(sync, 400);
      }
    });

    updateDeferUi();
    buildRows();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-envico-delegates]');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }

  ready(boot);
  document.addEventListener('shopify:section:load', boot);
})();
